// extracted by mini-css-extract-plugin
export default {"container":"tbd-label-wih-price_container__98Pjw"};